export enum CartNotificationTheme {
  GREEN = 'notification-theme-green',
  PURPLE = 'notification-theme-purple',
  RED = 'notification-theme-red',
  SUCCESS = 'notification-theme-success',
  YELLOW = 'notification-theme-yellow',
}
